import $ from 'jquery';

export default () => {
    let $cta = $(".cta-start-quiz");
    let $quiz_cnt = $("#quiz");

    $cta.click(e => {
        e.preventDefault();
        $quiz_cnt.removeClass("d-none");

        // Scroll to quiz
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#quiz").offset().top
        }, 500);
    });
};



// WEBPACK FOOTER //
// ../views/partials/test/test.js